import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"; // swap for useNavigate if you're on v6
import jwt_decode from "jwt-decode";
import axios from "axios";
import apiConfig from "../../apiConfig";


const S = {
  page: {
    fontFamily: "'Outfit', sans-serif",
    background: "#F7F9FC",
    width: "100%",
    boxSizing: "border-box",
    padding: "24px",
  },

  banner: {
    background: 'linear-gradient(120deg, #0066CC 0%, #0052A3 100%)',
    borderRadius: '14px',
    padding: '22px 28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '14px',
    marginBottom: '20px',
    boxShadow: '0 4px 20px rgba(0,102,204,0.2)',
    position: 'relative',
    overflow: 'hidden',
  },
  bannerBubble: {
    position: 'absolute',
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.06)',
    pointerEvents: 'none',
  },
  bannerLeft: { position: 'relative', zIndex: 1 },
  bannerGreet: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexWrap: "wrap",
  },
  bannerUID: {
    marginTop: '6px',
    fontSize: '13px',
    color: 'rgba(255,255,255,0.7)',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
  },
  bannerActions: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
    position: 'relative',
    zIndex: 1,
  },
  bannerBtn: (bg, color = '#fff') => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '10px 20px',
    borderRadius: '9px',
    fontSize: '13px',
    fontWeight: 700,
    border: 'none',
    cursor: 'pointer',
    background: bg,
    color,
    fontFamily: "'Outfit', sans-serif",
    whiteSpace: 'nowrap',
  }),

  balancePill: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px 12px",
    borderRadius: "9999px",
    background: "#10B981",
    color: "#fff",
    border: "2px solid #059669",
    fontWeight: 700,
    fontSize: "12px",
    letterSpacing: ".3px",
  },

  idPill: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
    padding: "8px 18px",
    borderRadius: "9999px",
    background: "#3B82F6",
    color: "#fff",
    border: "2px solid #1D4ED8",
    fontWeight: 700,
    fontSize: "13px",
    letterSpacing: ".3px",
  },

  trustCard: {
    background: "#FFFFFF", borderRadius: "14px", padding: "24px 28px",
    border: "1px solid #EFEFEF", marginBottom: "20px",
    width: "100%", boxSizing: "border-box",
  },
  trustLabel: { fontSize: "18px", fontWeight: 700, color: "#0066CC", marginBottom: "8px" },
  trustValue: { fontSize: "34px", fontWeight: 800, color: "#111" },
  trustUnit: { fontSize: "16px", fontWeight: 600, color: "#999", marginLeft: "6px" },
  statusRow: { display: "flex", alignItems: "center", gap: "8px", marginTop: "14px", fontSize: "15px", color: "#333" },
  dot: (ok) => ({ width: "12px", height: "12px", borderRadius: "50%", background: ok ? "#2ECC71" : "#E8380A" }),
  minTrust: { color: "#999", fontSize: "13px", marginTop: "14px" },
  minTrustVal: { color: "#111", fontWeight: 700, fontSize: "15px" },

  actionRow: { display: "flex", gap: "14px", marginTop: "20px" },
  btnPrimary: {
    flex: 1, padding: "13px", borderRadius: "9px", border: "none",
    background: "#0066CC", color: "#fff", fontWeight: 700, fontSize: "14px", cursor: "pointer",
  },
  btnSecondary: {
    flex: 1, padding: "13px", borderRadius: "9px", border: "1px solid #EFEFEF",
    background: "#EAF3FF", color: "#0066CC", fontWeight: 700, fontSize: "14px", cursor: "pointer",
  },

  section: {
    background: "#FFFFFF", borderRadius: "14px", border: "1px solid #EFEFEF",
    padding: "22px", marginBottom: "20px", width: "100%", boxSizing: "border-box",
    overflowX: "auto",
  },
  sectionHead: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px", flexWrap: "wrap", gap: "10px" },
  sectionTitle: { fontSize: "18px", fontWeight: 700, color: "#111" },
  headBtns: { display: "flex", gap: "8px" },
  resetBtn: { padding: "8px 14px", borderRadius: "8px", border: "1px solid #EFEFEF", background: "#F7F9FC", color: "#555", fontSize: "13px", fontWeight: 600, cursor: "pointer" },
  downloadBtn: { padding: "8px 14px", borderRadius: "8px", border: "none", background: "#0066CC", color: "#fff", fontSize: "13px", fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" },

  filterRow: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "10px", marginBottom: "16px", width: "100%",
  },
  select: {
    padding: "9px 12px",
    borderRadius: "8px",
    border: "1px solid #EFEFEF",
    fontSize: "13px",
    color: "#333",
    WebkitTextFillColor: "#333",
    background: "#fff",
    fontFamily: "'Outfit', sans-serif",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
  },

  // date input wrapper -> custom label overlay
  dateWrap: {
    position: "relative",
    width: "100%",
    display: "flex",
    alignItems: "center",
  },
  dateLabel: (empty) => ({
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: "13px",
    color: "#999",
    pointerEvents: "none",
    opacity: empty ? 1 : 0,
    transition: "opacity 0.1s",
  }),

  statGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "14px", width: "100%" },
  statCard: { background: "#F7F9FC", borderRadius: "12px", padding: "16px 18px", display: "flex", alignItems: "center", justifyContent: "space-between", minWidth: 0 },
  statLabel: { fontSize: "13px", color: "#999", fontWeight: 500, marginBottom: "4px" },
  statValue: { fontSize: "22px", fontWeight: 800, color: "#111" },
  statIcon: { width: "34px", height: "34px", borderRadius: "8px", background: "#E8F0FE", color: "#0066CC", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },

  // NEW: history table
  table: { width: "100%", borderCollapse: "collapse", marginTop: "18px", minWidth: "600px" },
  th: { textAlign: "left", padding: "10px 12px", fontSize: "12px", color: "#999", fontWeight: 700, textTransform: "uppercase", borderBottom: "2px solid #EFEFEF", whiteSpace: "nowrap" },
  td: { padding: "10px 12px", fontSize: "13px", color: "#333", borderBottom: "1px solid #F1F1F1", whiteSpace: "nowrap" },
  emptyRow: { padding: "24px", textAlign: "center", color: "#999", fontSize: "13px" },
  statusBadge: (status) => {
    const s = String(status || "").toLowerCase();
    const map = {
      paid: { bg: "#E7F8EF", color: "#12A150" },
      pending: { bg: "#FFF6E5", color: "#B8860B" },
      reject: { bg: "#FDEAEA", color: "#D9363E" },
    };
    const c = map[s] || { bg: "#F1F1F1", color: "#666" };
    return {
      display: "inline-block", padding: "4px 10px", borderRadius: "9999px",
      fontSize: "11px", fontWeight: 700, background: c.bg, color: c.color, textTransform: "capitalize",
    };
  },
  pagerRow: { display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "10px", marginTop: "14px" },
  pagerBtn: (disabled) => ({
    padding: "7px 14px", borderRadius: "7px", border: "1px solid #EFEFEF",
    background: disabled ? "#F7F9FC" : "#fff", color: disabled ? "#ccc" : "#0066CC",
    fontSize: "13px", fontWeight: 600, cursor: disabled ? "not-allowed" : "pointer",
  }),
  pagerText: { fontSize: "13px", color: "#666" },
};

const GlobalCSS = () => (
  <style>{`
    input.td-select[type="date"].td-date-empty::-webkit-datetime-edit-fields-wrapper,
    input.td-select[type="date"].td-date-empty::-webkit-datetime-edit-text,
    input.td-select[type="date"].td-date-empty::-webkit-datetime-edit-month-field,
    input.td-select[type="date"].td-date-empty::-webkit-datetime-edit-day-field,
    input.td-select[type="date"].td-date-empty::-webkit-datetime-edit-year-field {
      color: transparent;
    }
  `}</style>
);

const FilterResponsiveCSS = () => (
  <style>{`
    @media (max-width: 480px) {
      .td-page { padding: 12px !important; }
      .td-banner { padding: 16px 18px !important; }
      .td-card { padding: 14px 16px !important; margin-bottom: 12px !important; }
      .td-stat-grid { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; gap: 8px !important; }
      .td-stat-card { padding: 10px 12px !important; }
      .td-stat-value { font-size: 17px !important; }
      .td-stat-label { font-size: 11px !important; }
      .td-stat-icon { width: 26px !important; height: 26px !important; }
      .td-filter-row { gap: 8px !important; margin-bottom: 10px !important; }
      .td-select { padding: 7px 9px !important; font-size: 12px !important; }
      .td-section-title { font-size: 16px !important; }

      .td-select {
        color: #333 !important;
        -webkit-text-fill-color: #333 !important;
      }
      input.td-select[type="date"]::-webkit-calendar-picker-indicator {
        filter: invert(0.5);
      }
    }
  `}</style>
);

const StatBox = ({ label, value }) => (
  <div style={S.statCard} className="td-stat-card">
    <div>
      <div style={S.statLabel} className="td-stat-label">{label}</div>
      <div style={S.statValue} className="td-stat-value">{value}</div>
    </div>
    <div style={S.statIcon} className="td-stat-icon"><i className="material-icons" style={{ fontSize: "18px" }}>bar_chart</i></div>
  </div>
);

const FilterBar = ({ fields, values, onChange }) => (
  <div style={S.filterRow} className="td-filter-row">
    {fields.map((f) => {
      if (f.type === "date") {
        const isEmpty = !values[f.key];
        return (
          <div key={f.key} style={S.dateWrap}>
            <input
              type="date"
              style={S.select}
              className={`td-select ${isEmpty ? "td-date-empty" : ""}`}
              value={values[f.key] || ""}
              onChange={(e) => onChange(f.key, e.target.value)}
            />
            <span style={S.dateLabel(isEmpty)}>{f.label}</span>
          </div>
        );
      }
      if (f.options) {
        return (
          <select key={f.key} style={S.select} className="td-select" value={values[f.key] || ""} onChange={(e) => onChange(f.key, e.target.value)}>
            <option value="">{f.label}</option>
            {f.options.map((o) => <option key={o} value={o}>{o}</option>)}
          </select>
        );
      }
      return (
        <input
          key={f.key}
          type="text"
          style={S.select}
          className="td-select"
          value={values[f.key] || ""}
          onChange={(e) => onChange(f.key, e.target.value)}
          placeholder={f.label}
        />
      );
    })}
  </div>
);

// NEW: history table, shared by Deposit and Withdraw sections.
// `kind` picks which fields to read off each row since deposit/withdraw
// documents use different field names (wallet_type vs selected_method,
// send_amount_in_bdt vs withdraw_amount_in_bdt).
const HistoryTable = ({ rows, kind, loading }) => {
  const methodKey = kind === "deposit" ? "wallet_type" : "selected_method";
  const amountKey = kind === "deposit" ? "send_amount_in_bdt" : "withdraw_amount_in_bdt";

  if (loading) {
    return <div style={S.emptyRow}>Loading...</div>;
  }
  if (!rows || rows.length === 0) {
    return <div style={S.emptyRow}>No transactions found.</div>;
  }

  return (
    <div style={{ overflowX: "auto" }}>
      <table style={S.table}>
        <thead>
          <tr>
            <th style={S.th}>Date</th>
            <th style={S.th}>Phone</th>
            <th style={S.th}>TrxID</th>
            <th style={S.th}>Method</th>
            <th style={S.th}>Amount</th>
            <th style={S.th}>Status</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row._id}>
              <td style={S.td}>{row.createdAt ? new Date(row.createdAt).toLocaleString() : "-"}</td>
              <td style={S.td}>{row.sender_number || "-"}</td>
              <td style={S.td}>{row.trxid || "-"}</td>
              <td style={S.td}>{row[methodKey] || "-"}</td>
              <td style={S.td}>{row[amountKey] != null ? Number(row[amountKey]).toLocaleString("en-BD") : "-"}</td>
              <td style={S.td}><span style={S.statusBadge(row.status)}>{row.status || "-"}</span></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const Pager = ({ page, pageCount, onPrev, onNext }) => (
  <div style={S.pagerRow}>
    <span style={S.pagerText}>Page {page} of {pageCount || 1}</span>
    <button style={S.pagerBtn(page <= 1)} disabled={page <= 1} onClick={onPrev}>Prev</button>
    <button style={S.pagerBtn(!pageCount || page >= pageCount)} disabled={!pageCount || page >= pageCount} onClick={onNext}>Next</button>
  </div>
);

/* -- date range builders matching daily_deposit / daily_withdraw params -- */
function toDateStr(d) { return d.toISOString().slice(0, 10); }

function bucketRanges() {
  const now = new Date();
  const today = toDateStr(now);

  const y = new Date(now); y.setDate(y.getDate() - 1);
  const yesterday = toDateStr(y);

  const s7 = new Date(now); s7.setDate(s7.getDate() - 6);
  const last7Start = toDateStr(s7);

  const som = new Date(now.getFullYear(), now.getMonth(), 1);
  const monthStart = toDateStr(som);

  return { today, yesterday, last7Start, monthStart };
}

function cleanParams(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== "" && v !== undefined && v !== null)
  );
}

const HISTORY_LIMIT = 20;

const TrustDashboard = () => {
  const history = useHistory();

  const token = localStorage.getItem("jwtToken");
  let decodedToken = null;
  try {
    decodedToken = token ? jwt_decode(token) : null;
  } catch (err) {
    console.error("Invalid token:", err);
  }
  const user_id = decodedToken ? decodedToken.user_id : null;
  const userID = decodedToken ? decodedToken.user_id : null;

  const [balanceData, setBalanceData] = useState(null);

  const [depoStats, setDepoStats] = useState({
    today: 0, todayAmt: 0,
    yesterday: 0, yesterdayAmt: 0,
    last7Days: 0, last7Amt: 0,
    thisMonth: 0, thisMonthAmt: 0,
    total: 0, totalAmt: 0,
  });
  const [withStats, setWithStats] = useState({
    today: 0, todayAmt: 0,
    yesterday: 0, yesterdayAmt: 0,
    last7Days: 0, last7Amt: 0,
    thisMonth: 0, thisMonthAmt: 0,
    total: 0, totalAmt: 0,
    range: 0, rangeAmt: 0,
  });
  const [pendingDeposit, setPendingDeposit] = useState(0);
  const [pendingWithdraw, setPendingWithdraw] = useState(0);

  const [depoFilters, setDepoFilters] = useState({});
  const [withFilters, setWithFilters] = useState({});
  const [downloading, setDownloading] = useState(null);

  // NEW: history table state � separate from the stat counters above,
  // since stats only ever request limit:1 (just needs totalUsers/totalAmount).
  const [depoRows, setDepoRows] = useState([]);
  const [depoPage, setDepoPage] = useState(1);
  const [depoPageCount, setDepoPageCount] = useState(1);
  const [depoLoading, setDepoLoading] = useState(false);

  const [withRows, setWithRows] = useState([]);
  const [withPage, setWithPage] = useState(1);
  const [withPageCount, setWithPageCount] = useState(1);
  const [withLoading, setWithLoading] = useState(false);

  const fetchStat = async (endpoint, extraParams = {}) => {
    const params = cleanParams({ user_id: user_id, limit: 1, page: 1, ...extraParams });
    const res = await axios.get(`${apiConfig.baseURL}/api/users/${endpoint}`, { params });
    return {
      count: res.data.totalUsers || 0,
      amount: res.data.totalAmount || 0,
    };
  };

  const fetchDepoStats = useCallback(async (filters) => {
    try {
      const { today, yesterday, last7Start, monthStart } = bucketRanges();
      const base = { status: "paid", ...filters };
      const [t, y, l7, m, total] = await Promise.all([
        fetchStat("daily_deposit", { startDate: today, endDate: today, ...base }),
        fetchStat("daily_deposit", { startDate: yesterday, endDate: yesterday, ...base }),
        fetchStat("daily_deposit", { startDate: last7Start, endDate: today, ...base }),
        fetchStat("daily_deposit", { startDate: monthStart, endDate: today, ...base }),
        fetchStat("daily_deposit", { ...base }),
      ]);
      setDepoStats({
        today: t.count, todayAmt: t.amount,
        yesterday: y.count, yesterdayAmt: y.amount,
        last7Days: l7.count, last7Amt: l7.amount,
        thisMonth: m.count, thisMonthAmt: m.amount,
        total: total.count, totalAmt: total.amount,
      });
    } catch (err) { console.error(err); }
  }, [user_id]);

  const fetchWithStats = useCallback(async (filters) => {
    try {
      const { today, yesterday, last7Start, monthStart } = bucketRanges();

      const hasRange = filters.startDate || filters.endDate;
      const rangeParams = hasRange
        ? { startDate: filters.startDate || monthStart, endDate: filters.endDate || today }
        : null;

      const base = { status: "Paid", ...filters };
      delete base.startDate;
      delete base.endDate;

      const [t, y, l7, m, total, range] = await Promise.all([
        fetchStat("daily_withdraw", { startDate: today, endDate: today, ...base }),
        fetchStat("daily_withdraw", { startDate: yesterday, endDate: yesterday, ...base }),
        fetchStat("daily_withdraw", { startDate: last7Start, endDate: today, ...base }),
        fetchStat("daily_withdraw", { startDate: monthStart, endDate: today, ...base }),
        fetchStat("daily_withdraw", { ...base }),
        rangeParams ? fetchStat("daily_withdraw", { ...base, ...rangeParams }) : Promise.resolve({ count: 0, amount: 0 }),
      ]);
      setWithStats({
        today: t.count, todayAmt: t.amount,
        yesterday: y.count, yesterdayAmt: y.amount,
        last7Days: l7.count, last7Amt: l7.amount,
        thisMonth: m.count, thisMonthAmt: m.amount,
        total: total.count, totalAmt: total.amount,
        range: range.count, rangeAmt: range.amount,
      });
    } catch (err) { console.error(err); }
  }, [user_id]);

  // NEW: full row fetch for the history tables (uses the SAME status
  // defaults as the stat cards � "paid" for deposit, "Paid" for withdraw �
  // so the table matches what the stats above are counting).
  const fetchDepoRows = useCallback(async (filters, page) => {
    setDepoLoading(true);
    try {
      const params = cleanParams({ user_id, limit: HISTORY_LIMIT, page, status: "paid", ...filters });
      const res = await axios.get(`${apiConfig.baseURL}/api/users/daily_deposit`, { params });
      setDepoRows(res.data.result || []);
      setDepoPageCount(res.data.pageCount || 1);
    } catch (err) {
      console.error(err);
      setDepoRows([]);
    } finally {
      setDepoLoading(false);
    }
  }, [user_id]);

  const fetchWithRows = useCallback(async (filters, page) => {
    setWithLoading(true);
    try {
      const params = cleanParams({ user_id, limit: HISTORY_LIMIT, page, status: "Paid", ...filters });
      const res = await axios.get(`${apiConfig.baseURL}/api/users/daily_withdraw`, { params });
      setWithRows(res.data.result || []);
      setWithPageCount(res.data.pageCount || 1);
    } catch (err) {
      console.error(err);
      setWithRows([]);
    } finally {
      setWithLoading(false);
    }
  }, [user_id]);

  const fetchPendingCounts = useCallback(async () => {
    try {
      const [depoRes, withRes] = await Promise.all([
        axios.get(`${apiConfig.baseURL}/api/users/pending_balance_request`, { params: { user_id, status: "pending", page: 1, limit: 1 } }),
        axios.get(`${apiConfig.baseURL}/api/users/pending_withdraw_request`, { params: { user_id, status: "Pending", page: 1, limit: 1 } }),
      ]);
      setPendingDeposit(depoRes.data.totalUser || 0);
      setPendingWithdraw(withRes.data.totalUser || 0);
    } catch (err) { console.error(err); }
  }, [user_id]);

  const fetchBalance = useCallback(async () => {
    try {
      const res = await axios.get(`${apiConfig.baseURL}/api/users/shows/${userID}`);
      setBalanceData(res.data);
    } catch (err) { console.error(err); }
  }, [userID]);

  useEffect(() => { fetchBalance(); }, [fetchBalance]);
  useEffect(() => { fetchPendingCounts(); }, [fetchPendingCounts]);
  useEffect(() => { fetchDepoStats(depoFilters); }, [depoFilters, fetchDepoStats]);
  useEffect(() => { fetchWithStats(withFilters); }, [withFilters, fetchWithStats]);

  // NEW: reset to page 1 whenever filters change, then fetch rows for
  // whatever page is current (page reset happens in resetDepo/onChange below)
  useEffect(() => { fetchDepoRows(depoFilters, depoPage); }, [depoFilters, depoPage, fetchDepoRows]);
  useEffect(() => { fetchWithRows(withFilters, withPage); }, [withFilters, withPage, fetchWithRows]);

  const resetDepo = () => { setDepoFilters({}); setDepoPage(1); };
  const resetWith = () => { setWithFilters({}); setWithPage(1); };

  const onDepoFilterChange = (k, v) => { setDepoFilters((p) => ({ ...p, [k]: v })); setDepoPage(1); };
  const onWithFilterChange = (k, v) => { setWithFilters((p) => ({ ...p, [k]: v })); setWithPage(1); };

  const downloadReport = async (type, filters) => {
    setDownloading(type);
    try {
      const params = new URLSearchParams(cleanParams(filters)).toString();
      const res = await axios.get(`${apiConfig.baseURL}/api/${type}/download?${params}`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${type}-report-${Date.now()}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error(err);
      alert(`Download failed: ${err.message}`);
    } finally {
      setDownloading(null);
    }
  };

  const goDeposit = () => history.push("/pending-balance-request");
  const goWithdraw = () => history.push("/pending-withdraw-request");

  const fmt = (n) => `${Number(n || 0).toLocaleString("en-BD")} TK`;

  return (

      <div className="content-body">
        <div className="container-fluid">
      <div style={S.page} className="td-page">
      <GlobalCSS />
      <FilterResponsiveCSS />
      <div style={S.banner} className="td-banner">
        <div style={{ ...S.bannerBubble, width: 180, height: 180, top: -60, right: 80 }} />
        <div style={{ ...S.bannerBubble, width: 100, height: 100, bottom: -30, right: 20 }} />

			<div style={S.bannerGreet}>
			<span style={S.balancePill}>
				<i className="material-icons" style={{ fontSize: 14 }}>account_balance_wallet</i>{" "}
				{balanceData?.[0]
				? parseFloat(balanceData[0].currency).toFixed(2)
				: "0.00"}{" "}
				TK
			</span>

			<span style={S.idPill}>
				<i className="material-icons" style={{ fontSize: 16 }}>badge</i>
				ID: {balanceData?.[0]?.user_id ?? userID}
			</span>
			</div>

      <div style={S.bannerActions}>
          <button style={S.bannerBtn("rgba(255,255,255,0.15)", "#fff")} onClick={goDeposit}>
            <i className="material-icons" style={{ fontSize: "16px" }}>arrow_downward</i> Deposit
          </button>
          <button style={S.bannerBtn("rgba(255,255,255,0.15)", "#fff")} onClick={goWithdraw}>
            <i className="material-icons" style={{ fontSize: "16px" }}>arrow_upward</i> Withdraw
          </button>
        </div>
      </div>

      <div style={S.trustCard} className="td-card">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: "12px" }}>
          <div style={S.trustLabel}>Pending Requests</div>
        </div>
        <div style={S.statGrid} className="td-stat-grid">
          <StatBox label="Pending Deposit Requests" value={pendingDeposit} />
          <StatBox label="Pending Withdraw Requests" value={pendingWithdraw} />
        </div>
      </div>

      <div style={S.section}>
        <div style={S.sectionHead}>
          <span style={S.sectionTitle}>Deposit</span>
          <div style={S.headBtns}>
            <button style={S.resetBtn} onClick={resetDepo}>Reset Filters</button>
           
          </div>
        </div>
        <FilterBar
          fields={[
            { key: "startDate", label: "From Date", type: "date" },
            { key: "endDate", label: "To Date", type: "date" },
            { key: "wallet_type", label: "Payment Method", options: ["NAGAD", "BKASH"] },
            { key: "status", label: "Status", options: ["paid", "pending"] },
            { key: "search", label: "Search (Phone/TrxID/User)" },
          ]}
          values={depoFilters}
          onChange={onDepoFilterChange}
        />
        <div style={S.statGrid}>
          <StatBox label="Today" value={`${depoStats.today} / ${fmt(depoStats.todayAmt)}`} />
          <StatBox label="Yesterday" value={`${depoStats.yesterday} / ${fmt(depoStats.yesterdayAmt)}`} />
          <StatBox label="Last 7 Days" value={`${depoStats.last7Days} / ${fmt(depoStats.last7Amt)}`} />
          <StatBox label="This Month" value={`${depoStats.thisMonth} / ${fmt(depoStats.thisMonthAmt)}`} />
          <StatBox label="Total Transactions" value={`${depoStats.total} / ${fmt(depoStats.totalAmt)}`} />
        </div>
        <HistoryTable rows={depoRows} kind="deposit" loading={depoLoading} />
        <Pager
          page={depoPage}
          pageCount={depoPageCount}
          onPrev={() => setDepoPage((p) => Math.max(1, p - 1))}
          onNext={() => setDepoPage((p) => Math.min(depoPageCount, p + 1))}
        />
      </div>

      <div style={S.section}>
        <div style={S.sectionHead}>
          <span style={S.sectionTitle}>Withdraw</span>
          <div style={S.headBtns}>
            <button style={S.resetBtn} onClick={resetWith}>Reset Filters</button>
            
          </div>
        </div>
        <FilterBar
          fields={[
            { key: "startDate", label: "From Date", type: "date" },
            { key: "endDate", label: "To Date", type: "date" },
            { key: "selected_method", label: "Payment Method", options: ["bkash", "Nagad"] },
            { key: "status", label: "Status", options: ["Paid", "Pending", "Reject"] },
            { key: "search", label: "Search (Phone/TrxID/User)" },
          ]}
          values={withFilters}
          onChange={onWithFilterChange}
        />
        <div style={S.statGrid}>
          <StatBox label="Today" value={`${withStats.today} / ${fmt(withStats.todayAmt)}`} />
          <StatBox label="Yesterday" value={`${withStats.yesterday} / ${fmt(withStats.yesterdayAmt)}`} />
          <StatBox label="Last 7 Days" value={`${withStats.last7Days} / ${fmt(withStats.last7Amt)}`} />
          <StatBox label="This Month" value={`${withStats.thisMonth} / ${fmt(withStats.thisMonthAmt)}`} />
          <StatBox label="Total Transactions" value={`${withStats.total} / ${fmt(withStats.totalAmt)}`} />
          <StatBox label="Range Total" value={`${withStats.range} / ${fmt(withStats.rangeAmt)}`} />
        </div>
        <HistoryTable rows={withRows} kind="withdraw" loading={withLoading} />
        <Pager
          page={withPage}
          pageCount={withPageCount}
          onPrev={() => setWithPage((p) => Math.max(1, p - 1))}
          onNext={() => setWithPage((p) => Math.min(withPageCount, p + 1))}
        />
      </div>
      </div>
        </div>
      </div>

  );
};

export default TrustDashboard;